import { isV2Group, type V2ContentNode, type V2LogbookDef } from "../types";

// @IMPLEMENTATION NOTE: PURE DATA ARCHITECTURE (Future Upgrade)
// Once the JSON logbook schemas are updated to ensure all 'group' and 'item' IDs
// are globally unique across the entire file (e.g. replacing repetitive "ID2" / "1"
// with unique semantic paths or UUIDs), we can remove this `serializeLogbookForBackend`
// stripping logic entirely.
//
// At that point, `entryData` can act as a pure data map accessed via `set(entryData, path, value)`,
// and can be sent directly to the backend without cloning or pruning the UI reference tree.

export function serializeLogbookForBackend(
  logbook: V2LogbookDef,
  values: Record<string, any>,
): V2LogbookDef {
  const cleanLogbook = JSON.parse(JSON.stringify(logbook)) as V2LogbookDef;

  function processNode(node: V2ContentNode): V2ContentNode {
    if (isV2Group(node)) {
      // Strip runtime properties
      delete node.rowInstance;
      delete (node as any).id;
      delete (node as any)._inherited;
      delete (node as any)._path;

      if (node.content) {
        node.content = node.content.map(processNode);
      }
      return node;
    } else {
      // Hydrate values
      if (node.id && values[node.id] !== undefined) {
        node.value = values[node.id];
      } else {
        // ensure it's removed or null if empty
        delete node.value;
      }

      delete node.id;
      delete (node as any)._inherited;
      delete (node as any)._path;
      return node;
    }
  }

  if (cleanLogbook.content) {
    cleanLogbook.content = cleanLogbook.content.map(processNode);
  }

  return cleanLogbook;
}
